import { API_BASE_URL, buildHeaders, callApi } from './apiClient';

/**
 * Fetch funnel configuration by sub-domain
 * @param {string} subDomain
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const fetchFunnelConfig = async (subDomain) => {
  if (!subDomain) {
    return { success: false, error: 'Sub-domain is required' };
  }

  const query = new URLSearchParams({ sub_domain: subDomain });
  const endpoint = `${API_BASE_URL}/api/funnel/config?${query.toString()}`;

  return callApi(endpoint, {
    method: 'GET',
    headers: buildHeaders()
  });
};


